import type { LinksLookup } from 'src/translators/links-lookup';

// When modifying an existing entry here, you might need to add an NGINX redirect from the old URL to the new one,
// in italy.template
export const linksLookup: LinksLookup = {
  'book-a-tour': 'prenota-un-tour',
  'club-facilities': 'strutture-club',
  'club-treatments': 'club-treatments',
  'club-fitness': 'club-fitness',
  'creche': 'nido',
  'exercise-classes': 'corsi',
  'gym': 'palestra',
  'sports': 'sports',
  'kids-classes': 'corsi-per-bambini',
  'children': 'children',
  'pools': 'piscine',
  'spa': 'spa',
  'tennis': 'tennis',
  'enquire-now': 'contattaci-subito',
  'enquiry-form': 'contattaci-subito',
  'family-and-kids': 'famiglia-e-bambini',
  'golf': 'golf',
  'join-now': 'iscriviti-subito',
  'manage-your-tour': 'gestisci-il-tuo-tour',
  'membership-trial': 'iscrizione-di-prova',
  'relax-and-socialise': 'rilassati-e-socializza',
  'timetable': 'calendario',
  'yoga': 'yoga',
  'blaze': 'blaze',
  'personal-training': 'personal-training',
  'join': 'iscriviti',
  // If this link is changed, we should:
  // - Update nginx OJ route handling
  // - Update MSS/Common in the backend
  // - Update the links stored in CC e.g. see DLLABS-10292 (or add an nginx redirect from the old route)
  'join-online': 'iscriviti-online',
  // TODO Redesign: Check over these translations
  'membership-type': 'tipo-di-iscrizione',
  'members': 'membri',
  'personal-details': 'dati-personali',
  'your-price': 'il-tuo-prezzo',
  'treatments': 'face-body-spa',
  'global-enquire-now': 'contattaci-subito',
  'memberships': 'iscrizione',
  'terms-and-conditions': 'termini-e-condizioni',
  'policy': 'politica',
  'careers': 'carriere',
  'digital-signature': 'firma-digitale',
  'young-adult': 'giovane-adulto',
  'family': 'famiglia',
  'gyms-in-milan': 'palestre-a-milano',
};
